import { useSelector } from 'react-redux';
import { selectChartType, selectTimePeriod } from '@reducers/params';
import { ALL_MACHINES } from '@helpers';
import { CHART_TYPE } from '@v2/pages/common/constants/base.constants';
import { selectSelectedItem } from '@reducers/machines';

export const useHandleParams = () => {
  const timePeriod = useSelector(selectTimePeriod);
  const chartType = useSelector(selectChartType);
  const selectedItem = useSelector(selectSelectedItem);
  const id = selectedItem?.id;

  const isAllSelected = id === ALL_MACHINES;
  const showLineChart = chartType === CHART_TYPE.LINE;

  return { id, isAllSelected, timePeriod, chartType, showLineChart };
};
